module.exports = __webpack_public_path__ + "static/media/badge_money_2.88438e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_money_2.png
// module id = 506
// module chunks = 0